// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/

export const get_platforms = in_offer=>{
    const offer = in_offer || {};
    const has_all = offer.platforms?.includes('all');
    const has_android = has_all || offer.platforms?.includes('android');
    const has_ios = has_all || offer.platforms?.includes('ios');
    const has_desktop = has_all || offer.platforms?.includes('desktop');
    return {has_all, has_android, has_ios, has_desktop};
};
